import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { debouncedCloseRubric, debouncedOpenRubric } from '../../actions/dropdown';
import { NavBar } from '../../components/NavBar';
import { selectNavbarRubrics } from '../../selectors/rubricLinks';
import { selectHasSpecialPromo } from '../../selectors/specialPromos';
import { ERubric } from '../../types/rubricsLinks';
import { SpecialPromosDesktopContainer } from '../SpecialPromosDesktopContainer/SpecialPromosDesktopContainer';

export const NavBarContainer = () => {
  const dispatch = useDispatch();
  const hasSpecialPromo = useSelector(selectHasSpecialPromo);
  const navbarRubrics = useSelector(selectNavbarRubrics);

  const handleRubricMouseOver = React.useCallback(
    (rubric: ERubric) => {
      dispatch(debouncedOpenRubric(rubric));
    },
    [dispatch],
  );

  const handleRubricMouseOut = React.useCallback(() => {
    dispatch(debouncedCloseRubric());
  }, [dispatch]);

  return (
    <NavBar
      rubricsLinks={navbarRubrics}
      onItemMouseOut={handleRubricMouseOut}
      onItemMouseOver={handleRubricMouseOver}
      specialPromo={hasSpecialPromo ? <SpecialPromosDesktopContainer /> : null}
    />
  );
};
